import ExpertConsultationSvg from "../../Icons/ExpertConsultationSvg";
import FinancingAssistanceSvg from "../../Icons/FinancingAssistanceSvg";
import DedicatedRelationshipManagersSvg from "../../Icons/DedicatedRelationshipManagersSvg";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  CenteredGridWithHeading,
} from "@reusejs/react";
import SectionHeading from "../SectionHeading";
import { useRouter } from "next/router";

const Icon = (props: any) => {
  return (
    <div className="p-2.5 lg:p-5 rounded lg:rounded-xl bg-blue-100">
      {props.iconObject}
    </div>
  );
};

const Actions = (props: any) => {
  const router = useRouter();
  const handleRedirect = () => {
    router.push(props.link);
  };
  return (
    <div
      className="text-blue-600 cursor-pointer"
      onClick={() => handleRedirect()}
    >
      {"Learn More >"}
    </div>
  );
};

const items = [
  {
    title: "Expert Consultation",
    description:
      "We will coordinate between Banks and Investors and save time for both parties involved in the transaction.",
    icon: <Icon iconObject={<ExpertConsultationSvg />} />,
    actions: <Actions link="/services#expert-consulting" />,
  },
  {
    title: "Financing Assistance",
    description:
      "We will structure an exceptional finance package with various alternate modes and assist potential investors with up to 60% of the bid value.",
    icon: <Icon iconObject={<FinancingAssistanceSvg />} />,
    actions: <Actions link="/services#financing-assistance" />,
  },
  {
    title: "Dedicated Relationship Managers",
    description:
      "We assign a dedicated relationship manager for end-to-end handling of transactions. Our dedicated Relationship Manager will assist you in the entire bidding journey.",
    icon: <Icon iconObject={<DedicatedRelationshipManagersSvg />} />,
    actions: <Actions link="/services#dedicated-relationship-manager" />,
  },
];

const ItemRendererComponent = (props?: any) => {
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            description={item.description}
            actions={item.actions}
            iconPosition="top-center"
            itemTitleDescriptionCardBaseClasses={{
              iconWrapper:
                "flex items-center justify-center rounded-md mx-auto",
              titleWrapper: "mt-2 text-center",
              titleStyles: `${
                props.home
                  ? "text-lg md:text-xl font-bold"
                  : "text-base md:text-lg lg:text-xl font-medium md:font-bold"
              }  text-gray-900`,
              descriptionWrapper: "text-center mt-2",
              descriptionStyles: `${
                props.home ? "text-sm md:text-base" : "text-base font-normal"
              } text-gray-500`,
              actionWrapper: "mt-2 text-center",
            }}
          />
        );
      })}
    </>
  );
};

export default function ServicesComponent(props: any) {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
      }}
    >
      <CenteredGridWithHeading
        headingSection={
          <SectionHeading
            title={props.servicesSectionData.heading.title}
            description={props.servicesSectionData.heading.description}
            itemTitleDescriptionCardBaseClasses={{
              wrapper: "mb-10",
              titleWrapper: "text-center",
              titleStyles: `${
                props.home
                  ? "text-2xl md:text-3xl font-extrabold"
                  : "text-xl md:text-2xl font-semibold"
              }  sm:text-4xl`,
              descriptionWrapper: "text-center mt-3 sm:mt-4",
              descriptionStyles: "text-sm md:text-lg text-gray-500",
            }}
          />
        }
        sectionContentData={items}
        itemsRenderer={() => (
          <ItemRendererComponent home={props.home} items={items} />
        )}
        centeredGridBaseClasses={{
          gridClasses:
            "grid sm:grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-8  md:space-y-0",
        }}
      />
    </SectionContainerBase>
  );
}
